export const PERSONAL_LIBRARY_SORT_SESSION_KEY =
  'library-content:personal-sort';

export const SHARED_LIBRARY_SORT_SESSION_KEY = 'library-content:shared-sort';
